export default "__VITE_ASSET__UFZyY2yR__"